(() => {
	angular.module('main').directive('updateCreditCard', updateCreditCard);

	function updateCreditCard() {
		return {
			restrict: 'E',
			scope: {
				subscribtionEnd: '=',
				subscribtionRenew: '='
			},
			template: `
                        <div class="btn-subscription flex-row flex-wrap-xs flex-align-center">
                            <div class="pr-30">
                                <p class="text-nowrap f-s-14-i">Paid until
                                    <span>{{subscribtionEnd | timeFilter : 'long'}}</span>
                                </p>
                                <p class="text-nowrap f-s-14-i">Renews on
                                    <span>{{subscribtionRenew | timeFilter : 'long'}}</span>
                                </p>
                            </div>
                            <btn-update-card-det></btn-update-card-det>
                        </div>
                    `,
			replace: true,
			transclude: true
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Subscription/updateCreditCard.js